<template>
  <v-col class="py-0">
    <v-row>
      <v-img
        v-bind:src="getImgUrl(path)"
        
        :max-height="height"
        class="img-width"
      ></v-img>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    path: String,
    height:Number
  },
  methods: {
    getImgUrl(path) {      
      const url = require(`../assets/${path}`);
      return url;
    },
  },
};
</script>

<style lang="scss">
@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xl-only')} {
  .img-width {
    max-width: 1920px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>